import * as Yup from 'yup';

const actionTemplateValidationSchema = Yup.object().shape({
  title: Yup.string().required('Title is required'),
  shortDescription: Yup.string().required('Short description is required'),
  criticality: Yup.string(),
  area: Yup.string().required('Area is required'),
  subarea: Yup.string(),
  assetTypes: Yup.array(),
  checklist: Yup.array()
    .of(
      Yup.object().shape({
        title: Yup.string().required('Step title is required'),
        instruction: Yup.string().required('Step instruction is required'),
        isMandatory: Yup.boolean().required('Mandatory field is required'),
      }),
    )
    .min(1, 'At least one checklist step is required'),
});

export default actionTemplateValidationSchema;
